export default __webpack_public_path__ + "static/media/603.905d9997.jpg";